// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3SF_o","primary":"Button_primary__3jQq5","info":"Button_info__11qVV","outline":"Button_outline__2Zk1L"};